import { StudentsCsvValidatePage } from 'teacher-ui-client/components/page/students-csv/validate'
import RouteTemplate from 'ember-route-template'

export default RouteTemplate(StudentsCsvValidatePage)
